let utils = require( './utils' );

let checkout_sidebar = function( $ ) {

	let $sidebar,
		anim_speed = 400;

	let init = function() {
		$sidebar = $( '#checkout-sidebar' );

		if ( $sidebar.length > 0 ) {
			_setup_sidebar_toggles();

			if ( utils.viewport_size().width <= 992 ) {
				_setup_sidebar_toggle();
			}
		}
	};

	// Main sidebar collapse for mobile screens
	let _setup_sidebar_toggle = function() {
		$sidebar.find( '.sidebar-title' ).on( 'click', function( e ) {
			e.preventDefault();

			_toggle_sidebar();
		} )
	};

	let _setup_sidebar_toggles = function() {
		$sidebar.find( 'a.toggle-more-days' ).on( 'click', function( e ) {
			e.preventDefault();

			_toggle_days_panel( $( this ).closest( '.ticket-wrapper' ) );
		} );

		$sidebar.find( 'a.toggle-delegates-info' ).on( 'click', function( e ) {
			e.preventDefault();

			_toggle_delegates_panel( $( this ).closest( '.ticket-wrapper' ) );
		} );
	};

	let _toggle_sidebar = function() {
		let $panels = $sidebar.find( '.toggle-section' );

		if ( $panels.hasClass( 'animating' ) ) {
			return;
		}

		$panels.addClass( 'animating' );

		if ( $panels.hasClass( 'open' ) ) {
			_close_sidebar();
		} else {
			_open_sidebar();
		}

		setTimeout( () => {
			$panels.removeClass( 'animating' );
		}, anim_speed );
	};

	let _open_sidebar = function() {
		$sidebar.find( '.sidebar-title' ).addClass( 'open' );

		$sidebar.find( '.toggle-section' ).slideDown( anim_speed );
		$sidebar.find( '.toggle-section' ).addClass( 'open' );
		$sidebar.find( '.toggle-section' ).removeClass( 'closed' );
	};

	let _close_sidebar = function() {
		$sidebar.find( '.sidebar-title' ).removeClass( 'open' );

		$sidebar.find( '.toggle-section' ).slideUp( anim_speed );
		$sidebar.find( '.toggle-section' ).addClass( 'closed' );
		$sidebar.find( '.toggle-section' ).removeClass( 'open' );
	};

	let _toggle_days_panel = function( $ticket_wrapper ) {
		let $panel = $ticket_wrapper.find( '.more-days' );


		if ( $panel.hasClass( 'animating' ) ) {
			return;
		}

		if ( $panel.hasClass( 'open' ) ) {
			_close_panel( $panel, $ticket_wrapper.find( 'a.toggle-more-days' ) );
		} else {
			_open_panel( $panel, $ticket_wrapper.find( 'a.toggle-more-days' ) );
		}

		$panel.addClass( 'animating' );

		setTimeout( () => {
			$panel.removeClass( 'animating' );
		}, anim_speed );
	};

	let _toggle_delegates_panel = function( $ticket_wrapper ) {
		let $panel = $ticket_wrapper.find( '.delegates-info-panel' );

		if ( $panel.hasClass( 'animating' ) ) {
			return;
		}

		if ( $panel.hasClass( 'open' ) ) {
			_close_panel( $panel, $ticket_wrapper.find( 'a.toggle-delegates-info' ) );
		} else {
			_open_panel( $panel, $ticket_wrapper.find( 'a.toggle-delegates-info' ) );
		}

		$panel.addClass( 'animating' );

		setTimeout( () => {
			$panel.removeClass( 'animating' );
		}, anim_speed );
	};

	let _open_panel = function( $panel, $toggle_link ) {
		$panel.slideDown( anim_speed );
		$panel.addClass( 'open' );
		$panel.removeClass( 'closed' );

		$toggle_link.addClass( 'open' );
		$toggle_link.removeClass( 'closed' );
	};

	let _close_panel = function( $panel, $toggle_link ) {
		$panel.slideUp( anim_speed );
		$panel.addClass( 'closed' );
		$panel.removeClass( 'open' );

		$toggle_link.addClass( 'closed' );
		$toggle_link.removeClass( 'open' );
	};

	$( document ).ready( init );

	return {
		init: init
	};

} ( jQuery );

module.exports = checkout_sidebar;

